<style scoped>
@media screen and (max-width: 641px){
  .breads{
    display: none!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .con{
    display: none!important;
  }
  .gene_img{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  .gene_img img{
    width: 100%;
  }
  .c-title{
    margin-top: 10px;
  }
}
.cons{
  display: none;
}
</style>
<template>
  <div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="c-title">全国布局</div>
    <div class="con">
      <div class="wrap">
        <div class="wraps" id="contains">
          <p>地区：{{mapSelParam1}}</p>
          <p>电话：{{mapSelParam2}}</p>
          <p>测序邮箱：{{mapSelParam4}}</p>
          <p>合成邮箱：{{mapSelParam5}}</p>
          <p>地址：{{mapSelParam3}}</p>
        </div>
        <div class="screen" ref="screen"></div>
      </div>
    </div>
    <div class="cons">
      <div class="gene_img">
        <img src="@/assets/images/compose_map.png">
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import '@/utils/china'
import  '@/utils/china.json'
import bread from "@/components/bread"
export default {
  name: 'default',
  data() {
    return {
      mapSelParam: '',//选中的参数
      mapSelParam1: '',
      mapSelParam2: '',
      mapSelParam3: '',
      mapSelParam4: '',
      mapSelParam5: '',
      echart: {
        title: '全国布局',   //选中的省份
        zoom: 0.4
      }
    };
  },
  components: {
    bread
  },
  methods: {
    initEcharts(){
      //初始化echarts
      let echartApp = echarts.init(this.$refs.screen);
      //设置配置项
      echartApp.setOption(this.getEchartsOptions())
      //自适应
      window.addEventListener('resize', function () {
        echartApp.resize();
      });
      //点击各省份事件处理
      let _this = this;
      echartApp.on('click', param => {
        //获取到的省份名
        let temp = JSON.stringify(this.mapSelParam);
        if(this.mapSelParam){
          //取消选中前一次选中的省份
          echartApp.dispatchAction({
            type: 'geoUnSelect',
            seriesIndex: this.mapSelParam.seriesIndex,
            seriesName: this.mapSelParam.seriesName,
            dataIndex: this.mapSelParam.dataIndex,
            name: this.mapSelParam.name
          })
          let container1 = document.getElementById('contains');
          container1.style.display = "none";
          this.mapSelParam1 = '';
          this.mapSelParam2 = '';
          this.mapSelParam3 = '';
          this.mapSelParam4 = '';
          this.mapSelParam5 = '';
        }
        this.mapSelParam = {
          seriesIndex: param.seriesIndex,
          seriesName: param.seriesName,
          dataIndex: param.dataIndex,
          name: param.name
        }
        //*********************************
        //***为选中的省份的参数赋值**********
        //*********************************
        echartApp.setOption(this.getEchartsOptions());
        //如果前一次选中与当前选中相同，则return，取消选中
        if(temp === JSON.stringify(this.mapSelParam)){
          echartApp.setOption(this.getEchartsOptions());
          this.mapSelParam = {};
          return;
        }
        //选中当前点击的省份
        echartApp.dispatchAction({
          type: 'geoSelect',
          seriesIndex: this.mapSelParam.seriesIndex,
          seriesName: this.mapSelParam.seriesName,
          dataIndex: this.mapSelParam.dataIndex,
          name: this.mapSelParam.name
        })
        let container1 = document.getElementById('contains');
        container1.style.display = "block";
        this.mapSelParam1 = param.name;
        this.mapSelParam2 = param.data.tel;
        this.mapSelParam3 = param.data.adress;
        this.mapSelParam4 = param.data.email;
        this.mapSelParam5 = param.data.email1;
      })
      this.$nextTick(() => {
        this.echart.zoom = 1.1;
        echartApp.setOption(this.getEchartsOptions());
      })
    },
    getEchartsOptions(){
      let dataList=[
        {name:"南海诸岛", tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '北京',value:9000, tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '天津',value:9000, tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'天津市武清开发区新创路6号健康产业园3号厂房一层西侧'},
        {name: '上海',value:9000, tel:'400-668-3730',email:'sh-seq@tsingke.com.cn(测序)',email1:'sh-synth@tsingke.com.cn(合成)',adress:'上海市闵行区浦江镇江月路999号19号楼4楼'},
        {name: '重庆',value:9000, tel:'400-668-3730',email:'cq-seq@tsingke.com.cn (测序)',email1:'cq-synth@tsingke.com.cn (合成)',adress:'重庆市沙坪坝区西园北街14号生产力服务大厦第3层'},
        {name: '河北', tel:'+86 0317-7581236',email:'sale@dnachem.com',email1:'cuihaotian@dnachem.com',adress:'河北省沧州市临港经济技术开发区西区经二路北侧迪纳兴科'},
        {name: '河南',value:9000, tel:'400-668-3730',email:'zz-seq@tsingke.com.cn (测序)',email1:'zz-synth@tsingke.com.cn (合成)',adress:'河南省郑州市高新区长椿路十一号国家大学科技园7号厂房E座5楼'},
        {name: '云南',value:9000, tel:'400-668-3730',email:'km-seq@tsingke.com.cn(测序)',email1:'km-synth@tsingke.com.cn(合成)',adress:'昆明市盘龙区都市产业园'},
        {name: '辽宁', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '黑龙江',value:9000, tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '湖南',value:9000, tel:'400-668-3730',email:'cs-seq@tsingke.com.cn(测序)',email1:'cs-synth@tsingke.com.cn (合成)',adress:'湖南省长沙市岳麓区银盆南路315号湘能大厦中栋6楼'},
        {name: '安徽', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '山东',value:9000, tel:'400-668-3730',email:'qd-seq@tsingke.com.cn (测序)',email1:'qd-synth@tsingke.com.cn (合成)',adress:'山东省青岛市高新区松园路17号工业技术研究院B1楼'},
        {name: '新疆', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '江苏',value:9000, tel:'400-668-3730',email:'nj-seq@tsingke.com.cn (测序)',email1:'nj-synth@tsingke.com.cn (合成)',adress:'南京市江宁区高新园乾德路9号2号楼5楼'},
        {name: '浙江',value:9000, tel:'400-668-3730',email:'hz-seq@tsingke.com.cn (测序)',email1:'hz-synth@tsingke.com.cn (合成)',adress:'浙江省杭州市西湖区西园八路2号B幢4层擎科生物'},
        {name: '江西', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '湖北',value:9000, tel:'400-668-3730',email:'wh-seq@tsingke.com.cn (测序)',email1:'wh-synth@tsingke.com.cn (合成)',adress:'武汉市东湖新技术开发区高科园三路9号武汉精准医疗产业基地6栋3层302室、6栋4层402室'},
        {name: '广西',value:9000, tel:'400-668-3730',email:'',email1:'nn-synth@tsingke.com.cn(合成)',adress:'广西省南宁市西乡塘区正鑫科技园实验楼701'},
        {name: '甘肃', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401' },
        {name: '山西', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '内蒙古', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '陕西',value:9000, tel:'400-668-3730',email:'xa-seq@tsingke.com.cn (测序)',email1:'xa-synth@tsingke.com.cn (合成)',adress:'西安市未央区尚稷路8989号西安服务外包产业园C座5层'},
        {name: '吉林', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '福建',value:9000, tel:'400-668-3730',email:'xm-seq@tsingke.com.cn (测序)',email1:'xm-synth@tsingke.com.cn(合成)',adress:'福建省福州市仓山区建新镇金洲北路33号1号楼五层513室'},
        {name: '贵州', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '广东',value:9000, tel:'400-668-3730',email:'gz-seq@tsingke.com.cn (测序)',email1:'gz-synth@tsingke.com.cn (合成)',adress:'广州市黄埔区开源大道188号一栋401房一栋501房'},
        {name: '青海', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '西藏', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '四川',value:9000, tel:'400-668-3730',email:'cd-seq@tsingke.com.cn (测序)',email1:'cd-synth@tsingke.com.cn (合成)',adress:'成都市高新区科园南路5号蓉药大厦A栋5楼'},
        {name: '宁夏', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '海南',value:9000, tel:'400-668-3730',email:'',email1:'hk-synth@tsingke.com.cn(合成)',adress:'海口市秀英区海榆中线199号金鹿工业区C10栋'},
        {name: '台湾', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '香港', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'},
        {name: '澳门', tel:'400-668-3730',email:'bj-seq@tsingke.com.cn (测序)',email1:'bj-synth@tsingke.com.cn (合成)',adress:'北京市北京经济技术开发区经海四路156号院5号楼401'}
      ];
      function randomValue() {
        return Math.round(Math.random()*1000);
      }
      return {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            console.log(params)
            if(params.data){
              return params.name+'<br/>电话：'+params.data.tel+'<br/>测序邮箱：'+params.data.email+'<br/>合成邮箱：'+params.data.email1+'<br/>地址：'+params.data.adress;   //自行定义formatter格式  (人数/占比)
            }
          }
        },
        // title: {
        //   text: this.echart.title,
        //   textStyle: {
        //     color: '#333',
        //     fontSize: 24
        //   },
        //   top: 20,
        //   left: 20
        // },
        geo: {
          //引入中国地图
          map: 'china',
          //是否可以缩放，拖拽
          roam: false,
          zoom: this.echart.zoom,
          //地名配置项
          label: {
            //默认情况下配置项
            normal: {
              show: true,
              textStyle: {
                color: '#333'
              }
            },
            //选中高亮情况下配置项
            emphasis: {
              textStyle: {
                color: '#FFF'
              }
            }
          },
          //各省样式
          itemStyle: {
            normal: {
              areaColor: '#fff',
              borderColor: '#389dff',
              borderWidth: 1,
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 10
            },
            emphasis: {
              areaColor: '#389dff',
              borderColor: '#389dff',
            }
          },
          scaleLimit: {
            min: 0.7,
            max: 10
          }
        },
        // visualMap: {
        //   type:'continuous',
        //   orient: 'horizontal', //控制条横向
        //   bottom:20,
        //   min: 0,
        //   max: 10000,
        //   inRange: {
        //     color: ['#81cde4','#ffd200','#ff0000']
        //   },
        //   text: ['高', '低'],  //
        //   // calculable: true, //是否显示拖把
        // },
        //设置各省份根据值(value)显示不同颜色
        //系列配置
        series: [{
          // name: '大数据',
          type: 'map',
          //【此参数必须配置，否则visualMap不起作用】
          geoIndex: 0,
          //此处可接收后端参数，当前数据仅为测试
          data:dataList,
        }],
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDelay: 2000
      }
    },
  },
  mounted(){
    //代码入口
    this.initEcharts();
  }
};
</script>
<style lang="css" scoped>
.wrap{
  min-height: 100%;
}
.wraps {
  display: none;
  width: 400px;
  float: right;
  margin-top: 50px;
  margin-right: 10px;
  color: #333;
  font-size: 14px;
  line-height: 25px;
}
.screen{
  width: 1000px;
  min-height: 800px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/summary/global.vue